// extracted by mini-css-extract-plugin
module.exports = {"headerBlock":"LandingPage_headerBlock__27fH2","auth":"LandingPage_auth__emzuB","info":"LandingPage_info__YVe16","content":"LandingPage_content__2PnFD"};